module.exports = __webpack_public_path__ + "img/li-circle-blue.3a6dfdcb.svg";